(function () {
    'use strict';


    angular.module('landingPageModule', [])
        .directive('landingPage', LandingPageDirective)
        .directive('bannerSection', BannerSectionDirective)
        .directive('leftAlignedImageSection', LeftAlignedImageSection)
        .directive('leftAlignedTextSection', LeftAlignedTextSection)
        .directive('shippingValuePropSection', ShippingValuePropSection)
        .directive('faqSection', FAQSection)
        .directive('imageRowSection', ImageRowSection)
        .directive('leftColumnSection', LeftColumnSection)
        .directive('rightColumnSection', RightColumnSection)
        .directive('productListSection', ProductListSection)
        .directive('valuePropSection', ValuePropositionSection)
        .directive('turnaroundPropSection', TurnaroundPropositionSection)
        .directive('bestSellersSection', BestSellersSection)
        .directive('configurableBrandsSection', ConfigurableBrandsSection)
        // Static
        .directive('merchSection', MerchSection)
        .directive('clientsSection', ClientsSection)
        .directive('reviewsSection', ReviewsSection)
        .directive('brandsSection', BrandsSection)
        .directive('popularCategoriesSection', PopularCategoriesSection)
        .directive('mapSection', MapSection)
        .directive('designReviewSection', DesignReviewSection)
        .directive('verticalItemList', VerticalItemList)
        .directive('locationSection', LocationSection)
        .directive('ourCompassSection', OurCompassSection)

    // other
        .directive('richtext', RichTextDirective);

    RichTextDirective.$inject = ['$rootScope']

    function RichTextDirective($rootScope) {
        var directive = {
            link: link,
            templateUrl: 'shared/js/widget/pageTemplate/rich-text-directive.html',
            restrict: 'EA',
            scope: {
                richHtml: '='
            }
        };
        return directive;

        function link($scope, element, attrs) {
        }
    }

    LandingPageDirective.$inject = ['CommonUtilService', '$rootScope', '$location', '$timeout'];

    function LandingPageDirective(CommonUtilService, $rootScope, $location, $timeout) {
        return {
            restrict: 'EA',
            scope: {
                pageTemplate: '=',
                locationMetadata: '=',
                currentLocale: '=',
                fromAdmin: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/landing-page.html',
            link: link
        };

        function link($scope, elem, attr) {
            activate();

            $scope.recSkus;
            $scope.disableProductSort;

            function activate() {
                var HEADER_SECTIONS = [
                    modelService.PAGE_SECTIONS.BANNER,
                    modelService.PAGE_SECTIONS.IMAGE_ROW,
                    modelService.PAGE_SECTIONS.LEFT_ALIGNED_TEXT,
                    modelService.PAGE_SECTIONS.LEFT_COLUMNED,
                    modelService.PAGE_SECTIONS.PRODUCTS,
                    modelService.PAGE_SECTIONS.FEATURED_PRODUCTS,
                    modelService.PAGE_SECTIONS.BEST_SELLERS
                ]

                var multipleProducts = _.filter($scope.pageTemplate.sections, function(section) {
                    return section.sectionProps.sectionType === modelService.PAGE_SECTIONS.PRODUCTS
                });
                $scope.disableProductFilters = multipleProducts.length > 1;


                var featuredProducts = _.find($scope.pageTemplate.sections, function(section) {
                    return section.sectionProps.sectionType === modelService.PAGE_SECTIONS.FEATURED_PRODUCTS
                })
                if (featuredProducts) {
                   $scope.recSkus = _.filter(_.map(featuredProducts.sectionProps.skus.dataProps.dataTypeList, function (productDataType) {
                        return productDataType.dataProps.sku;
                    }));
                }

                var headerIndex;
                var searchIndex = 0;
                while(!_.isNumber(headerIndex)) {
                    if (searchIndex >= $scope.pageTemplate.sections.length) {
                        break;
                    }

                    var sectionToCheck = $scope.pageTemplate.sections[searchIndex]
                    if (!sectionToCheck) {
                        break;
                    }
                    if (sectionToCheck.sectionVisible && HEADER_SECTIONS.includes(sectionToCheck.sectionProps.sectionType)) {
                        if (sectionToCheck.sectionProps.sectionType === modelService.PAGE_SECTIONS.BANNER) {
                            var bannerProps = sectionToCheck.sectionProps;
                            if (bannerProps.sectionHeader.dataProps.textValue) {
                                headerIndex = searchIndex;
                            }
                        } else if (sectionToCheck.sectionProps.sectionType === modelService.PAGE_SECTIONS.IMAGE_ROW) {
                            // sometimes image section has no text, if so the next section should be considered
                            var imageProps = sectionToCheck.sectionProps;
                            if (imageProps.title.dataProps.textValue) {
                                headerIndex = searchIndex;
                            }
                        } else if (sectionToCheck.sectionProps.sectionType === modelService.PAGE_SECTIONS.LEFT_ALIGNED_TEXT) {
                            var textProps = sectionToCheck.sectionProps;
                            if (textProps.sectionTitle.dataProps.textValue) {
                                headerIndex = searchIndex;
                            }
                        } else if (sectionToCheck.sectionProps.sectionType === modelService.PAGE_SECTIONS.FEATURED_PRODUCTS) {
                           // continue - deprecated
                        } else {
                            headerIndex = searchIndex;
                        }
                    }
                    searchIndex++;
                }

                if(_.isNumber(headerIndex)) {
                    $scope.headerSectionIndex = headerIndex;
                } else {
                    var foundSectionIndex = _.findIndex($scope.pageTemplate.sections, function(section) {
                        return section.sectionVisible;
                    })
                    if (foundSectionIndex > -1) {
                        $scope.headerSectionIndex = foundSectionIndex;
                    } else {
                        $scope.$emit('headerSectionLoaded');
                    }
                }
            }

            $scope.whenSectionReady = function(index) {
                    // console.log('Loaded: section ' + index + ' ' + $scope.pageTemplate.sections[index].sectionProps.sectionType);
                    if (index === $scope.headerSectionIndex) {
                        $scope.$emit('headerSectionLoaded');
                    }
            }

            $scope.sectionStyles = function(sectionStyles) {
                var styles = {}
                if (sectionStyles.backgroundColour) {
                    styles['background-color'] = sectionStyles.backgroundColour
                }
                return styles;
            }
        }
    }

    function BannerSectionDirective($timeout, $rootScope, matchmedia) {
        return {
            restrict: 'EA',
            scope: {
                isHeading: '=',
                bannerProps: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/banner-section.html',
            link: function($scope){
                $scope.banner = {
                    backgroundImage: ""
                }

                $scope.$watch('bannerProps', function(newValue, oldValue) {
                    if (oldValue) {
                        handleMediaChange();
                    }
                }, true)

                $scope.watchers = [];

                $scope.watchers.push(
                    matchmedia.onPhone(function(mediaQuery) {
                        if(matchmedia.isPhone()) {
                            handleMediaChange();
                        }
                    })
                )

                $scope.watchers.push(
                    matchmedia.onTablet(function(mediaQuery) {
                        if (matchmedia.isTablet()) {
                            handleMediaChange();
                        }
                    })
                )

                $scope.watchers.push(
                    matchmedia.onDesktop(function(mediaQuery) {
                        if (matchmedia.isDesktop()) {
                            handleMediaChange();
                        }
                    })
                )

                function handleMediaChange() {
                    if (matchmedia.isPhone() && $scope.bannerProps.backgroundImageMobile.dataProps.imageUrl) {
                        $scope.banner.deviceType = 'PHONE';
                        $scope.banner.backgroundImage = $scope.bannerProps.backgroundImageMobile.dataProps.imageUrl;
                    } else if (matchmedia.isTablet() && $scope.bannerProps.backgroundImageTablet.dataProps.imageUrl) {
                        $scope.banner.deviceType = 'TABLET';
                        $scope.banner.backgroundImage = $scope.bannerProps.backgroundImageTablet.dataProps.imageUrl;
                    } else {
                        $scope.banner.deviceType = 'DESKTOP';
                        $scope.banner.backgroundImage = $scope.bannerProps.backgroundImage.dataProps.imageUrl;
                    }
                    $scope.banner.noImageSrcSet = $scope.banner.deviceType === 'DESKTOP';
                    $scope.banner.backgroundImage = $rootScope.compressImage($scope.banner.backgroundImage);
                    // update scope after digest
                    $timeout(function() {
                       $scope.$apply()
                    })
                }

                $scope.$on('$destroy', function() {
                    _.forEach($scope.watchers, function(watcher){
                        watcher();
                    })
                })

                // banner styles
                $scope.mainBannerStyle = function() {
                    return {
                        'padding-top': !$scope.banner.backgroundImage ? '1vh' : '',
                        'padding-bottom': !$scope.banner.backgroundImage ? '1vh' : '',
                    }
                }
            }
        };
    }

    function LeftAlignedImageSection() {
        return {
            restrict: 'EA',
            scope: {
                laiProps: '=',
                isHeading: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/left-aligned-image-section.html',
            link: function($scope){
                $scope.isHeaderStyle = {};
                $scope.isBlogStyle = {};
                $scope.imageContainerStyle = {};
                $scope.aspectRatioStyle = {};

                try {
                    var isBlog = $scope.laiProps.isBlog.dataProps.booleanValue;
                    if (isBlog) {
                        if ($scope.isHeading) {
                            $scope.isHeaderStyle = {
                                'padding-left': '0px',
                                'padding-right': '0px'
                            }
                            $scope.isBlogStyle = {
                                'margin': 'auto',
                                'max-width': '1600px',
                                'overflow': 'hidden',
                                'max-height': '50vh'
                            }
                        } else {
                            $scope.isBlogStyle = {
                                'margin': 'auto'
                            }
                        }
                    }

                    var imageWidth = $scope.laiProps.imageWidth.dataProps.textValue;
                    var imageHeight = $scope.laiProps.imageHeight.dataProps.textValue;



                    if (imageWidth && imageHeight) {
                        // $scope.imageContainerStyle = {
                            // 'max-width' : imageWidth + 'px',
                            // 'max-height' : imageHeight + 'px',
                        // }
                        var aspectRatio = Number(imageHeight) / Number(imageWidth);
                        if (aspectRatio) {
                            $scope.aspectRatioStyle = {
                                'padding-bottom': 'calc(' + aspectRatio + ' * 100%)'
                            }
                        }
                    }

                } catch(e) {

                }

            }
        };
    }

    function LeftAlignedTextSection() {
        return {
            restrict: 'EA',
            scope: {
                latProps: '=',
                isHeading: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/left-aligned-text-section.html',
            link: function($scope){
                try {
                    $scope.isBlogStyle;
                    $scope.sectionStyle;

                    var isBlog = $scope.latProps.isBlog.dataProps.booleanValue;
                    if (isBlog) {
                        $scope.isBlogStyle = {
                            'margin': 'auto',
                        }

                        $scope.sectionStyle = {
                            'padding-top': $scope.latProps.disableTopPadding.dataProps.booleanValue ? '0': '25px',
                            'padding-bottom': $scope.latProps.disableBottomPadding.dataProps.booleanValue ? '0': '25px'
                        }
                    } else {
                        $scope.sectionStyle = {
                            'padding-top': $scope.latProps.disableTopPadding.dataProps.booleanValue ? '0': '5vw',
                            'padding-bottom': $scope.latProps.disableBottomPadding.dataProps.booleanValue ? '0': '5vw'
                        }
                    }
                } catch(e) {

                }
            }
        };
    }

    function ShippingValuePropSection() {
        return {
            restrict: 'EA',
            scope: {
                shipProps: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/shipping-value-prop-section.html',
            link : function($scope){
                $scope.getDueDate = function(shippingTimeOverride){
                    var shipTime;
                    if (shippingTimeOverride) {
                        shipTime = parseInt(shippingTimeOverride);
                    } else {
                        shipTime = 3;
                    }
                    var today = new Date()
                    var dueDate = moment(dateService.addBusinessDays(shipTime, today),"ddd MMM Do YYYY")
                    return {
                        month : moment(dueDate).format("MMM"),
                        date : moment(dueDate).format("D")
                    }
                };
            }
        };
    }

    function VerticalItemList() {
        return {
            restrict: 'EA',
            scope: {
                itemListProps: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/vertical-item-list-section.html',
            link: function($scope){
                $scope.itemList = []

                activate();

                function activate() {
                    getItemList();
                    // $scope.$watch("itemListProps", function() {
                    //     getItemList();
                    // }, true)
                }

                function getItemList() {
                    var images = $scope.itemListProps.images.dataProps.dataTypeList;
                    var headers = $scope.itemListProps.headers.dataProps.dataTypeList;
                    var descriptions = $scope.itemListProps.descriptions.dataProps.dataTypeList;

                    $scope.itemList = _.map(headers, function(header, index) {
                        return {
                            header: header,
                            image: images[index],
                            description: descriptions[index]
                        }
                    });
                }
            }
        };
    }

    function MapSection($rootScope, $sce, SEOService) {
        return {
            restrict: 'EA',
            scope: {
                mapProps: '=',
                city : '@city',
                province : '@province'
            },
            templateUrl: 'shared/js/widget/pageTemplate/map-section.html',
            link: function($scope){
                // console.log($scope.city)
                // console.log($scope.province)
                $scope.mapMetadata = {
                    mapUrl: "",
                    localPhone: "",
                    street1: "",
                    street2: "",
                    city: "",
                    province: "",
                    zip: "",
                    hours: ""
                }

                var vancouverMapMetadata = {
                    mapUrl:
                        $sce.trustAsResourceUrl("https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2606.7053090474706!2d-123.11972988475807!3d49.20614968411198!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5486769f38599947%3A0xfab5117abf828aea!2sCoastal%20Reign%20Printing!5e0!3m2!1sen!2sca!4v1613157174603!5m2!1sen!2sca"),
                    localPhone: $rootScope.phoneNumber ? $rootScope.phoneNumber.local : "",
                    street1: "8793 Cambie Street",
                    city: "Vancouver",
                    province: "BC",
                    zip: "V6P3J9",
                    hours: "Monday - Friday | 9:00 AM - 5:00 PM (PST)"
                }

                var torontoMapMetadata = {
                    mapUrl:
                        $sce.trustAsResourceUrl("https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11554.753761632093!2d-79.5144381!3d43.6130283!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xebbcec353dd53df7!2sCoastal%20Reign%20Printing%20Ltd!5e0!3m2!1sen!2sca!4v1644950179406!5m2!1sen!2sca"),
                    localPhone: $rootScope.phoneNumber ? $rootScope.phoneNumber.localToronto : "",
                    street1: "310 Judson Street",
                    street2: "Unit 3",
                    city: "Toronto",
                    province: "ON",
                    zip: "M8Z5T6",
                    hours: "Monday - Friday | 9:00 AM - 5:00 PM (EST)"
                }

                var calgaryMapMetadata = {
                    mapUrl:
                        $sce.trustAsResourceUrl("https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2508.401557435896!2d-114.08397068439176!3d51.04596007956624!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53716fe76e972825%3A0xf73991494c057f87!2sCoastal%20Reign%20Printing!5e0!3m2!1sen!2sca!4v1648166666666!5m2!1sen!2sca"),
                    localPhone: $rootScope.phoneNumber ? $rootScope.phoneNumber.localCalgary : "",
                    street1: "903 8 Ave SW",
                    street2: "9th Floor, Suite 900",
                    city: "Calgary",
                    province: "AB",
                    zip: "T2P0P7",
                    hours: "Monday - Friday | 9:00 AM - 5:00 PM (MST)"
                }

                var newYorkMapMetadata = {
                    mapUrl:
                        $sce.trustAsResourceUrl("https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3695.7445298284647!2d-73.98700572349871!3d40.74623973551804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2593957bcef7f%3A0xd89dedda4cab9127!2sCoastal%20Reign%20Printing!5e1!3m2!1sen!2sca!4v1740423326197!5m2!1sen!2sca"),
                    localPhone: $rootScope.phoneNumber ? $rootScope.phoneNumber.localNewYork : "",
                    street1: "136 Madison Avenue",
                    street2: "Suite 555-03",
                    city: "New York",
                    province: "NY",
                    zip: "10016",
                    hours: "Monday - Friday | 9:00 AM - 5:00 PM (EST)"
                }

                var locationOverride = !_.isEmpty($scope.mapProps) ? $scope.mapProps.locationOverride.dataProps.textValue: null;
                if(locationOverride) {
                    if (locationOverride.toLowerCase() == 'vancouver') {
                        $scope.locationInformation = true
                        $scope.mapMetadata = vancouverMapMetadata;
                    } else if (locationOverride.toLowerCase() == 'toronto') {
                        $scope.locationInformation = true
                        $scope.mapMetadata = torontoMapMetadata;
                    } else if (locationOverride.toLowerCase() == 'calgary') {
                        $scope.locationInformation = true
                        $scope.mapMetadata = calgaryMapMetadata;
                    } else if (locationOverride.toLowerCase() == 'new york') {
                        $scope.locationInformation = true
                        $scope.mapMetadata = newYorkMapMetadata;
                    }
                } else {
                    if ($scope.city == "Vancouver" && $scope.province == "BC") {
                        $scope.locationInformation = true
                        $scope.mapMetadata = vancouverMapMetadata
                    }
                    if ($scope.city == "Toronto" && $scope.province == "ON") {
                        $scope.locationInformation = true
                        $scope.mapMetadata = torontoMapMetadata
                    }
                    if ($scope.city == "Calgary" && $scope.province == "AB") {
                        $scope.locationInformation = true
                        $scope.mapMetadata = calgaryMapMetadata
                    }
                    if ($scope.city == "New York City" && $scope.province == "NY") {
                        $scope.locationInformation = true
                        $scope.mapMetadata = newYorkMapMetadata
                    }
                }
                if ($scope.locationInformation) {
                    $scope.jsonld = SEOService.localeBusinessSchema($scope.mapMetadata.city);
                }

                $scope.getStreet = function() {
                    var street2 = $scope.mapMetadata.street2 ? $scope.mapMetadata.street2 + " - ": "";
                    return street2 + $scope.mapMetadata.street1
                }
            }
        };
    }

    function ValuePropositionSection() {
        return {
            restrict: 'EA',
            scope: {
                valueProps: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/value-prop-section.html',
            link: function(){}
        };
    }

    function TurnaroundPropositionSection() {
        return {
            restrict: 'EA',
            scope: {
                turnaroundProps: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/turnaround-prop-section.html',
            link: function(){}
        };
    }

    DesignReviewSection.$inject = ['CountryService']
    function DesignReviewSection(CountryService) {
        return {
            restrict: 'EA',
            scope: {},
            templateUrl: 'shared/js/widget/pageTemplate/design-review-section.html',
            link: function($scope){
                $scope.popoverText = CountryService.textFindAndReplace('Our artists will send you over a high quality mockup with the placement, print size and specific colours used in your print. Your final print will match your mockup specifications, guaranteed.');
            }
        };
    }

    function PopularCategoriesSection($rootScope) {
        return {
            restrict: 'EA',
            scope: {},
            templateUrl: 'shared/js/widget/pageTemplate/popular-categories-section.html',
            link: function($scope){

                $scope.madeInLabel =  {
                    "dataProps": {
                        "textValue": $rootScope.fromUS() ? 'Made in USA' : "Made In Canada",
                        "url": $rootScope.fromUS() ? "custom-products/custom-clothing/made-in-usa": "custom-products/custom-clothing/made-in-canada",
                    },
                }

                $scope.madeInImage =   {
                    "dataProps": {
                        "imageUrl":
                            $rootScope.fromUS() ?
                                "https://file-uploads-cr.s3.amazonaws.com/Clothing%20Made%20in%20USA_1737065897561.png":
                                "https://file-uploads-cr.s3.amazonaws.com/Made%20in%20Canada%20clothing_1683050559479.jpg",
                        "imageHyperLink": $rootScope.fromUS() ? "custom-products/custom-clothing/made-in-usa": "custom-products/custom-clothing/made-in-canada",
                        "altText": "Browse products manufactured in " + $rootScope.fromUS() ? " the USA": "Canada",
                    },
                }
                $scope.genericCategories =
                    [
                        {
                            "sectionStyles": {
                                "paddingTop": false,
                                "paddingBottom": false
                            },
                            "sectionVisible": true,
                            "sectionProps": {
                                "title": {
                                    "dataProps": {
                                        "textValue": "Most Popular Categories"
                                    }
                                },
                                "hasPadding": {
                                    "dataProps": {
                                        "booleanValue": true
                                    }
                                },
                                "fitWidth": {
                                    "dataProps": {
                                        "booleanValue": false
                                    }
                                },
                                "images": {
                                    "dataProps": {
                                        "dataTypeList": [
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Stormtech%20Shirts_1683153552764.jpg",
                                                    "imageHyperLink": "custom-products/custom-clothing/t-shirts",
                                                    "altText": "An image of custom t-shirts that you can print your logo or design on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Jerzees%20Hoodies%20and%20Sweatshirts__1683064248197.jpg",
                                                    "imageHyperLink": "custom-products/custom-clothing/hoodies-sweaters",
                                                    "altText": "An image of custom hoodies and crewnecks that you can print your logo or design on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://s3.amazonaws.com/file-uploads-cr/Hats_1691771024734.jpg",
                                                    "imageHyperLink": "custom-products/custom-clothing/hats",
                                                    "altText": "An image of custom hats that you can embroider your logo or design on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Ecofriendly%20tote%20bags_1683050415972.jpg",
                                                    "imageHyperLink": "custom-products/custom-bags/tote-bags",
                                                    "altText": "An image of custom tote bags that you can print your logo or design on!"
                                                }
                                            }
                                        ]
                                    }
                                },
                                "labels": {
                                    "dataProps": {
                                        "dataTypeList": [
                                            {
                                                "dataProps": {
                                                    "textValue": "T-Shirts",
                                                    "url": "custom-products/custom-clothing/t-shirts"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Hoodies and Crewnecks",
                                                    "url": "custom-products/custom-clothing/hoodies-sweaters"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Hats",
                                                    "url": "custom-products/custom-clothing/hats"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Tote Bags",
                                                    "url": "custom-products/custom-bags/tote-bags"
                                                }
                                            }
                                        ]
                                    }
                                },
                                "cta": {
                                    "dataProps": {
                                        "textValue": ""
                                    }
                                },
                                "sectionType": "ImageRow"
                            },
                            "_id": "6451499deafa0da4c842e88b"
                        },
                        {
                            "sectionStyles": {
                                "paddingTop": false,
                                "paddingBottom": false
                            },
                            "sectionVisible": true,
                            "sectionProps": {
                                "title": {
                                    "dataProps": {
                                        "textValue": ""
                                    }
                                },
                                "hasPadding": {
                                    "dataProps": {
                                        "booleanValue": true
                                    }
                                },
                                "fitWidth": {
                                    "dataProps": {
                                        "booleanValue": false
                                    }
                                },
                                "images": {
                                    "dataProps": {
                                        "dataTypeList": [
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Coal%20Harbour%20Jackets_1683064324620.jpg",
                                                    "imageHyperLink": "custom-products/custom-clothing/jackets",
                                                    "altText": "An image of custom jackets that you can print your logo or design on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Vests%20copy_1687556439978.jpg",
                                                    "imageHyperLink": "custom-products/custom-clothing/jackets/vests",
                                                    "altText": "An image of custom vests that you can print your logo or design on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Custom%20Sport%20jerseys_1683050491889.jpg",
                                                    "imageHyperLink": "custom-products/jerseys",
                                                    "altText": "An image of custom jerseys that you can print your team's design on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://s3.amazonaws.com/file-uploads-cr/Drinkware_1697739528054.jpg",
                                                    "imageHyperLink": "custom-products/promotional/drinkware",
                                                    "altText": "An image of custom drinkware that you can print your logo or design on!"
                                                }
                                            }
                                        ]
                                    }
                                },
                                "labels": {
                                    "dataProps": {
                                        "dataTypeList": [
                                            {
                                                "dataProps": {
                                                    "textValue": "Jackets",
                                                    "url": "custom-products/custom-clothing/jackets"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Vests",
                                                    "url": "custom-products/custom-clothing/jackets/vests"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Jerseys",
                                                    "url": "custom-products/jerseys"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Drinkware",
                                                    "url": "custom-products/promotional/drinkware"
                                                }
                                            }
                                        ]
                                    }
                                },
                                "cta": {
                                    "dataProps": {
                                        "textValue": ""
                                    }
                                },
                                "sectionType": "ImageRow"
                            }
                        },
                        {
                            "sectionStyles": {
                                "paddingTop": false,
                                "paddingBottom": false
                            },
                            "sectionVisible": true,
                            "sectionProps": {
                                "title": {
                                    "dataProps": {
                                        "textValue": ""
                                    }
                                },
                                "hasPadding": {
                                    "dataProps": {
                                        "booleanValue": true
                                    }
                                },
                                "fitWidth": {
                                    "dataProps": {
                                        "booleanValue": false
                                    }
                                },
                                "images": {
                                    "dataProps": {
                                        "dataTypeList": [
                                            $scope.madeInImage,
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Christmas%20Gift_1683064440263.jpg",
                                                    "imageHyperLink": "custom-products/promotional/company-swag-box",
                                                    "altText": "An image of custom swag boxes that you can build and order for your company!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Ecofriendly_1687556390798.jpg",
                                                    "imageHyperLink": "custom-products/eco-friendly-products",
                                                    "altText": "An image of eco friendly sign, we offer a variety of eco friendly products that you can print your logo or design on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Notebooks_1683820761894.jpg",
                                                    "imageHyperLink": "custom-products/promotional/office-supplies/notebooks",
                                                    "altText": "An image of custom notebooks that you can print your logo or design on!"
                                                }
                                            }
                                        ]
                                    }
                                },
                                "labels": {
                                    "dataProps": {
                                        "dataTypeList": [
                                            $scope.madeInLabel,
                                            {
                                                "dataProps": {
                                                    "textValue": "Swag Boxes",
                                                    "url": "custom-products/promotional/company-swag-box"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Eco-Friendly",
                                                    "url": "custom-products/eco-friendly-products"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Notebooks",
                                                    "url": "custom-products/promotional/office-supplies/notebooks"
                                                }
                                            }
                                        ]
                                    }
                                },
                                "cta": {
                                    "dataProps": {
                                        "textValue": ""
                                    }
                                },
                                "sectionType": "ImageRow"
                            }
                        },
                        {
                            "sectionStyles": {
                                "paddingTop": false,
                                "paddingBottom": false
                            },
                            "sectionVisible": true,
                            "sectionProps": {
                                "title": {
                                    "dataProps": {
                                        "textValue": ""
                                    }
                                },
                                "hasPadding": {
                                    "dataProps": {
                                        "booleanValue": true
                                    }
                                },
                                "fitWidth": {
                                    "dataProps": {
                                        "booleanValue": false
                                    }
                                },
                                "images": {
                                    "dataProps": {
                                        "dataTypeList": [
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://s3.amazonaws.com/file-uploads-cr/Technology_1724875401005.jpg",
                                                    "imageHyperLink": "custom-products/promotional/tech",
                                                    "altText": "An image of technology gadgets that you can print your logo on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://s3.amazonaws.com/file-uploads-cr/Dress+Socks_1691787791428.jpg",
                                                    "imageHyperLink": "custom-products/custom-clothing/socks",
                                                    "altText": "An image of custom socks that you can print your logo or designs on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Patches_1683050631692_1687556069173.jpeg",
                                                    "imageHyperLink": "custom-products/patches",
                                                    "altText": "An image of custom patches that you can print your logo or design on!"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "imageUrl": "https://file-uploads-cr.s3.amazonaws.com/Shop%20by%20use_1683820891654.jpg",
                                                    "imageHyperLink": "custom-products",
                                                    "altText": "An image of custom products that you can print your logo or design on!"
                                                }
                                            }
                                        ]
                                    }
                                },
                                "labels": {
                                    "dataProps": {
                                        "dataTypeList": [
                                            {
                                                "dataProps": {
                                                    "textValue": "Technology",
                                                    "url": "custom-products/promotional/tech"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Socks",
                                                    "url": "custom-products/custom-clothing/socks"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "Patches",
                                                    "url": "custom-products/patches"
                                                }
                                            },
                                            {
                                                "dataProps": {
                                                    "textValue": "And More...",
                                                    "url": "custom-products"
                                                }
                                            }
                                        ]
                                    }
                                },
                                "cta": {
                                    "dataProps": {
                                        "textValue": ""
                                    }
                                },
                                "sectionType": "ImageRow"
                            }
                        }
                    ]
            }
        };
    }

    LocationSection.$inject = ['CommonUtilService']
    function LocationSection(CommonUtilService) {
        return {
            restrict: "EA",
            scope: {
                // from page template
                locationConfigOverrides: '=',
                locationProps: '=',
                preLink: '=',
                separator: '=',
                currentLocale: '=',
            },
            templateUrl: 'shared/js/widget/pageTemplate/location-section.html',
            link: function($scope){

                $scope.productNameDisplay;
                $scope.chunkedData;

                if($scope.locationProps) {
                    $scope.productNameDisplay = $scope.locationProps.productName.dataProps.textValue;
                }

                var allLocations = _.sortBy(getLocations(), function(location) {
                    return location.province + location.city;
                });
                var filteredLocations = _.filter(allLocations, function(location) {
                    var locationKey = getLocationKey(location);
                    return !location.canonical && location.locale == $scope.currentLocale &&
                        (!$scope.locationConfigOverrides[locationKey] ||
                            !$scope.locationConfigOverrides[locationKey].disabled
                        )
                })
                $scope.chunkedData = chunk(filteredLocations, 1);

                // $scope.$watch("locationProps", function() {
                //     if($scope.locationProps) {
                //         $scope.productNameDisplay = $scope.locationProps.productName.dataProps.textValue;
                //     }
                // }, true)

                // $scope.$watchGroup(["currentLocale", "locationConfigOverrides"], function() {
                // var filteredLocations = _.filter(allLocations, function(location) {
                //     var locationKey = getLocationKey(location);
                //     return !location.canonical && location.locale == $scope.currentLocale &&
                //         (!$scope.locationConfigOverrides[locationKey] ||
                //             !$scope.locationConfigOverrides[locationKey].disabled
                //         )
                // })
                // $scope.chunkedData = chunk(filteredLocations, 1);
                // }, true)

                function chunk(arr, size) {
                    var newArr = [];
                    for (var i=0; i<arr.length; i+=size) {
                        newArr.push(arr.slice(i, i+size));
                    }
                    return newArr;
                }

                $scope.getLink = function(location){
                    var urlOverride = $scope.locationProps.linkUrlOverride.dataProps.textValue;
                    if (urlOverride) {
                        var cityToken = modelService.PAGE_TEMPLATE_LOCATION_TOKENS.LOCATION_CITY;
                        var stateToken = modelService.PAGE_TEMPLATE_LOCATION_TOKENS.LOCATION_STATE;
                        return urlOverride
                            .replace(cityToken, CommonUtilService.replaceSpaceWithHyphensAndLower(location.city))
                            .replace(stateToken, CommonUtilService.replaceSpaceWithHyphensAndLower(location.province))
                    } else {
                        return $scope.preLink + $scope.separator + CommonUtilService.buildUrl(location)
                    }
                }
            }
        }
    }

    function OurCompassSection() {
        return {
            restrict: 'EA',
            scope: {},
            templateUrl: 'shared/js/widget/pageTemplate/our-compass-section.html',
            link: function(){}
        };
    }

    function ClientsSection($rootScope) {
        return {
            restrict: 'EA',
            scope: {},
            templateUrl: 'shared/js/widget/pageTemplate/clients-section.html',
            link: function($scope){
                activate();

                $scope.clients;

                function activate() {
                    if ($rootScope.fromUS()) {
                        $scope.clients = [
                            {
                                path: 'clientLogo/disney.png',
                                alt: 'We print tshirts for Disney Canada!',
                                imageWidth: 250,
                                imageHeight: 167
                            },
                            {
                                path: 'clientLogo/upenn.png',
                                alt: "University of Pennsylvania has ordered custom clothing from Coastal Reign.",
                                imageWidth: 250,
                                imageHeight: 167
                            },
                            {
                                path: 'clientLogo/microsoft.png',
                                alt: 'Microsoft Vancouver chooses Coastal Reign for their embroidered zip hoodies.',
                                imageWidth: 250,
                                imageHeight: 53
                            },
                            {
                                path: 'clientLogo/netflix.png',
                                alt: 'Netflix has ordered custom clothing from Coastal Reign.',
                                imageWidth: 250,
                                imageHeight: 76
                            },
                            {
                                path: 'clientLogo/princeton.png',
                                alt: 'Princeton student clubs love our design services and free shipping!',
                                imageWidth: 250,
                                imageHeight: 69
                            },
                            {
                                path: 'clientLogo/ebay.png',
                                alt: 'Coastal Reign has printed for Ebay!',
                                imageWidth: 250,
                                imageHeight: 100
                            },
                            {
                                path: 'clientLogo/amazon.png',
                                alt: 'Amazon chooses Coastal Reign to print their team specific hoodies and shirts!',
                                imageWidth: 250,
                                imageHeight: 75
                            },
                            {
                                path: 'clientLogo/tedx.png',
                                alt: 'Tedx orders custom clothing from Coastal Reign.',
                                imageWidth: 250,
                                imageHeight: 73
                            },
                        ]

                    } else {
                        $scope.clients = [
                            {
                                path: 'clientLogo/disney.png',
                                alt: 'We print tshirts for Disney Canada!',
                                imageWidth: 250,
                                imageHeight: 167
                            },
                            {
                                path: 'clientLogo/cityofvancouver.png',
                                alt: "The City of Vancouver, specifically the Board of Parks and Recreation division, has ordered custom clothing from Coastal Reign.",
                                imageWidth: 250,
                                imageHeight: 131
                            },
                            {
                                path: 'clientLogo/microsoft.png',
                                alt: 'Microsoft Vancouver chooses Coastal Reign for their embroidered zip hoodies.',
                                imageWidth: 250,
                                imageHeight: 53
                            },
                            {
                                path: 'clientLogo/netflix.png',
                                alt: 'Netflix has ordered custom clothing from Coastal Reign.',
                                imageWidth: 250,
                                imageHeight: 76
                            },
                            {
                                path: 'clientLogo/ubc-logo-crest-only.png',
                                alt: 'UBC student clubs love our design services and our free shipping!',
                                imageWidth: 250,
                                imageHeight: 125
                            },
                            {
                                path: 'clientLogo/bchydro.png',
                                alt: 'We embroidered jackets for BC Hydro.',
                                imageWidth: 250,
                                imageHeight: 79
                            },
                            {
                                path: 'clientLogo/amazon.png',
                                alt: 'Amazon chooses Coastal Reign to print their team specific hoodies and shirts!',
                                imageWidth: 250,
                                imageHeight: 75
                            },
                            {
                                path: 'clientLogo/uot.png',
                                alt: 'The University of Toronto orders custom clothing from Coastal Reign.',
                                imageWidth: 250,
                                imageHeight: 90
                            },
                        ]
                    }
                }
            }
        };
    }

    function BrandsSection(BrandService) {
        return {
            restrict: 'EA',
            scope: {},
            templateUrl: 'shared/js/widget/pageTemplate/brands-section.html',
            link: function($scope) {
                $scope.brands = [
                    'Carhartt', 'Adidas', 'Nike', 'AS Colour', 'Helly Hansen', 'Northface', 'Columbia', 'Herschel Bags',
                    'Roots', 'Gildan', 'Champion', 'Tentree', 'Russell Athletics', 'Bella and Canvas'
                ]

                    //['Gildan', 'Fruit of the Loom', 'American Apparel', 'Champion', 'Callaway', 'Roots', 'Tentree', 'Under Armour',
                //'Carhartt', 'Nike', 'Northface', 'Russell Athletics']
                BrandService.getAllBrands()
                    .then(function(allBrands) {
                        $scope.brands = _.map($scope.brands, function(brandName) {
                            return _.find(allBrands, function(brand) {
                                return brand.name === brandName
                            });
                        })
                    })
            }
        };
    }

    function ReviewsSection($timeout, $rootScope) {
        return {
            restrict: 'EA',
            scope: {},
            templateUrl: 'shared/js/widget/pageTemplate/reviews-section.html',
            link: function($scope, element, attrs){

                $scope.isLoading = false;
                $scope.isFinishedLoading = false;
                var containerElement = angular.element(element).find('#reviews-widget-container')[0]
                var reviewTemplate = '<div style="overflow-x: hidden" class="elfsight-app-73d009d3-06ea-4f44-ac62-eaf05d4c02a6" data-elfsight-app-lazy></div>'
                var isLoaded = document.querySelectorAll('script[src="https://static.elfsight.com/platform/platform.js"]');

                function checkScrollListener() {
                    var offTop = element.offset().top
                        var scrollPos = $(this).scrollTop();
                        if (!$scope.reviewWidgetTemplate && (Math.abs(scrollPos > (offTop - 1500)))) {
                            $scope.loadScript();
                        }
                    }

                $scope.loadScript = function () {
                    if ($scope.isLoading) {
                        return;
                    } else {
                        $scope.isLoading = true;
                    }

                    var isLoaded = document.querySelectorAll('script[src="https://static.elfsight.com/platform/platform.js"]');
                    // maybe it was loaded from a previous page or from floating widget
                    if (isLoaded.length > 0) {
                        $timeout(function () {
                            $scope.isFinishedLoading = true;
                            $scope.reviewWidgetTemplate = reviewTemplate
                            $scope.$apply();
                        })
                    } else {
                        var myScript = document.createElement("script");
                        myScript.src = 'https://static.elfsight.com/platform/platform.js';
                        document.body.appendChild(myScript);
                        myScript.onload = function () {
                            $timeout(function () {
                                $scope.reviewWidgetTemplate = reviewTemplate
                                $scope.$apply();
                            })
                        }
                    }

                    var fullyLoadedWidgetObserver = new MutationObserver(function(mutation) {
                        fullyLoadedWidgetObserver.disconnect();
                        setTimeout(function () {
                            // console.log('ig widget');
                            $scope.isFinishedLoading = true;
                            $scope.$apply();

                        }, 0)
                    })

                    var containerWidgetObserver = new MutationObserver(function(mutation) {
                        fullyLoadedWidgetObserver.observe(mutation[0].addedNodes[0], {subtree: true, childList:true})
                        containerWidgetObserver.disconnect();
                    });
                    containerWidgetObserver.observe(containerElement, {childList: true});

                    // fallback
                    setTimeout(function() {
                        $scope.isFinishedLoading = true;
                        $scope.$apply();
                    }, 3500)
                }
                window.addEventListener('scroll', checkScrollListener);

                // do not wait for scroll for prerender and load immediately.
                if ($rootScope.isPrerender()) {
                    $scope.loadScript();
                }

                $scope.$on('$destroy', function() {
                    window.removeEventListener("scroll", checkScrollListener)
                })
            }
        };
    }

    function MerchSection($timeout, $rootScope, matchmedia) {
        return {
            restrict: 'EA',
            scope: {},
            templateUrl: 'shared/js/widget/pageTemplate/merch-section.html',
            link: function($scope, element, attrs){
                resizeIg();
                $scope.isLoading = false;
                $scope.isFinishedLoading = false;
                var containerElement = angular.element(element).find('#ig-widget-container')[0]

                var htmlTemplate = '<behold-widget  feed-id="zmH9xVzo5AzUASR5FPmR"></behold-widget>'

                //reserve space - CLS
                function resizeIg() {
                    var isPhone = matchmedia.is("(max-width: 900px)");
                    var numBoxes;
                    var buffer;
                    if (isPhone) {
                        numBoxes = 1
                        buffer = 15
                    } else {
                        numBoxes = 4;
                        buffer = 50;
                    }

                    document.getElementById("ig-container").style.height = ((Math.min(2500, window.innerWidth ) + buffer) / numBoxes) + 'px'
                }

                window.addEventListener('resize', resizeIg);
                $scope.loadScript = function () {
                    if ($scope.isLoading) {
                        return;
                    } else {
                        $scope.isLoading = true;
                    }

                    // maybe it was loaded from a previous page
                    if (isScriptLoaded && isScriptLoaded.length > 0) {
                        $timeout(function () {
                            $scope.igWidgetTemplate = htmlTemplate
                        })
                    } else {
                        var myScript = document.createElement("script");
                        myScript.src = 'https://w.behold.so/widget.js';
                        myScript.type = 'module'
                        myScript.className = 'ig-feed-script';
                        document.body.appendChild(myScript);
                        myScript.onload = function () {
                            $timeout(function () {
                                $scope.igWidgetTemplate = htmlTemplate })
                        }
                    }
                    var fullyLoadedWidgetObserver = new MutationObserver(function() {
                        fullyLoadedWidgetObserver.disconnect();
                        $timeout(function () {
                            // console.log('ig widget');
                            $scope.isFinishedLoading = true;
                        }, 0)
                    })

                    var containerWidgetObserver = new MutationObserver(function(mutation) {
                        fullyLoadedWidgetObserver.observe(mutation[0].addedNodes[0].shadow, {childList:true})
                        containerWidgetObserver.disconnect();
                    });
                    containerWidgetObserver.observe(containerElement, {subtree: true, childList: true});

                    // fallback
                    $timeout(function() {
                        $scope.isFinishedLoading = true;
                    }, 5000)
                }

                // do not wait for scroll for prerender and load immediately.
                if ($rootScope.isPrerender()) {
                    $scope.loadScript();
                }

                // <script type="module" src="https://w.behold.so/widget.js"></script>
                var isScriptLoaded = document.querySelectorAll('.ig-feed-script');
                if (isScriptLoaded.length > 0) {
                    $scope.loadScript();
                } else {
                    window.addEventListener('scroll', checkScrollListener);
                }


                function checkScrollListener() {
                    var offTop = element.offset().top
                    $(window).on("scroll",function() {
                        var scrollPos = $(this).scrollTop()

                        if (!$scope.igWidgetTemplate && (scrollPos > (offTop - 1000))) {
                            $scope.loadScript();
                        }
                    })
                }

                $scope.$on('$destroy', function() {
                    window.removeEventListener("scroll", checkScrollListener)
                    window.removeEventListener('resize', resizeIg)
                })
                checkScrollListener();
            }
        };
    }

    function FAQSection(SEOService, $timeout) {
        return {
            restrict: 'EA',
            scope: {
                faqProps: '=',
                fromAdmin: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/faq-section.html',
            link: function($scope){
                $scope.faqList = []
                $scope.generateSchema = !$scope.faqProps.hideTitle.dataProps.booleanValue;
                activate();

                function activate() {
                    getFaqList();
                    // $scope.$watch("faqProps", function() {
                    //     getFaqList();
                    // }, true)
                }

                // console.log($scope.faqProps)

                function getFaqList() {
                    var questions = $scope.faqProps.questions.dataProps.dataTypeList;
                    var answers = $scope.faqProps.answers.dataProps.dataTypeList;

                    $scope.faqList = _.map(questions, function(question, index) {
                        return {
                            question: question,
                            answer: answers[index]
                        }
                    });

                    $scope.faqList[0].visible = true

                    if ($scope.fromAdmin) {
                        _.forEach($scope.faqList, function(faq) {
                            faq.visible = true
                        })
                    }
                    if ($scope.faqList.length > 0 && $scope.generateSchema) {
                        var faqPageSchema = SEOService.generateFaqTemplateSchema($scope.faqProps);
                        $scope.$emit('updatePageJsonSchema', faqPageSchema);
                    }
                }
            }
        };
    }

    function ImageRowSection() {
        return {
            restrict: 'EA',
            scope: {
                isHeading: '=',
                imageProps: '=',
            },
            templateUrl: 'shared/js/widget/pageTemplate/image-row-section.html',
            link: function($scope, elem,attr) {
                $scope.images = [];
                $scope.imageStyle = {};

                function activate() {
                    var images = $scope.imageProps.images.dataProps.dataTypeList;
                    var labels = $scope.imageProps.labels.dataProps.dataTypeList;

                    $scope.images = _.map(images, function(image, index) {
                        var label = labels[index];
                        if (label) {
                            if (!label.dataProps.url && image.dataProps.imageHyperLink) {
                                label.dataProps.url = image.dataProps.imageHyperLink
                            }
                        }
                        return {
                            image: image,
                            label: label
                        }
                    });

                    var hasPadding = $scope.imageProps.hasPadding.dataProps.booleanValue;
                    var style = {}
                    if (hasPadding) {
                        style.padding = "1%"
                    }

                    var fitWidth = $scope.imageProps.fitWidth.dataProps.booleanValue;
                    if (fitWidth) {
                        var numImages = $scope.imageProps.images.dataProps.dataTypeList.length;
                        var width;
                        if (numImages) {
                            width = (100 / numImages).toFixed(0);
                            style.width = width + "%"
                        }
                    }
                    $scope.imageStyle = style;

                    // $scope.$watch('imageProps', function() {
                    //
                    // }, true)
                }
                activate();
            }
        };
    }

    LeftColumnSection.$inject = ['$sce'];
    function LeftColumnSection($sce) {
        return {
            restrict: 'EA',
            scope: {
                leftColumnProps: '=',
                isHeading: '=',
            },
            templateUrl: 'shared/js/widget/pageTemplate/left-column-section.html',
            link: function($scope){
                // Initialize variables
                $scope.titleHtml = '';
                $scope.hasTitleText = false;
                
                // Generate heading HTML once
                function generateHeadingHtml(tag, text, url) {
                    if (!text) return '';
                    
                    var html = '';
                    if (url) {
                        html = '<' + tag + ' style="font-size: 24px !important;"><a style="text-decoration: none;" href="' + url + '">' + text + '</a></' + tag + '>';
                    } else {
                        html = '<' + tag + ' style="font-size: 24px !important;">' + text + '</' + tag + '>';
                    }
                    
                    return $sce.trustAsHtml(html);
                }
                
                // Determine which title to use and update the model
                function activate() {
                    if (!$scope.leftColumnProps) return;
                    
                    // Check if h2 title is available
                    var h2TitleData = $scope.leftColumnProps.titleH2Text && 
                                      $scope.leftColumnProps.titleH2Text.dataProps;
                    
                    // Check if h3 title is available
                    var h3TitleData = $scope.leftColumnProps.titleText && 
                                      $scope.leftColumnProps.titleText.dataProps;
                    
                    var text = '';
                    var url = '';
                    var tag = 'h3';
                    
                    // Simplified logic: Prefer h2 unless only h3 has custom locale/location content
                    var useH2 = h2TitleData && h2TitleData.textValue;
                    var useH3 = h3TitleData && h3TitleData.textValue;
                    
                    // Special case: if h2 exists but has no custom content, and h3 has custom content, prefer h3
                    if (useH2 && useH3 && 
                        !h2TitleData.cstmCnt && h3TitleData.cstmCnt) {
                        useH2 = false; // Switch to h3 only in this specific case
                    } else if (useH2) {
                        useH3 = false; // Standard behavior: prefer h2 when available
                    }
                    
                    // Set the selected title data
                    if (useH2) {
                        text = h2TitleData.textValue;
                        url = h2TitleData.url || '';
                        tag = 'h2';
                    } else if (useH3) {
                        text = h3TitleData.textValue;
                        url = h3TitleData.url || '';
                        tag = 'h3';
                    }
                    
                    // If we have text and isHeading is true, use h1 tag
                    if (text && $scope.isHeading) {
                        tag = 'h1';
                    }
                    
                    // Generate the HTML once
                    if (text) {
                        $scope.titleHtml = generateHeadingHtml(tag, text, url);
                        $scope.hasTitleText = true;
                    }
                }

                activate();
            }
        };
    }

    RightColumnSection.$inject = ['$sce'];
    function RightColumnSection($sce) {
        return {
            restrict: 'EA',
            scope: {
                rightColumnProps: '=',
                isHeading: '='
            },
            templateUrl: 'shared/js/widget/pageTemplate/right-column-section.html',
            link: function($scope){
                // Initialize variables
                $scope.titleHtml = '';
                $scope.hasTitleText = false;
                
                // Generate heading HTML once
                function generateHeadingHtml(tag, text, url) {
                    if (!text) return '';
                    
                    var html = '';
                    if (url) {
                        html = '<' + tag + ' style="font-size: 24px !important;"><a style="text-decoration: none;" href="' + url + '">' + text + '</a></' + tag + '>';
                    } else {
                        html = '<' + tag + ' style="font-size: 24px !important;">' + text + '</' + tag + '>';
                    }
                    
                    return $sce.trustAsHtml(html);
                }
                
                // Determine which title to use and update the model
                function activate() {
                    if (!$scope.rightColumnProps) return;
                    
                    // Check if h2 title is available
                    var h2TitleData = $scope.rightColumnProps.titleH2Text && 
                                      $scope.rightColumnProps.titleH2Text.dataProps;
                    
                    // Check if h3 title is available
                    var h3TitleData = $scope.rightColumnProps.titleText && 
                                      $scope.rightColumnProps.titleText.dataProps;
                    
                    var text = '';
                    var url = '';
                    var tag = 'h3';
                    
                    // Simplified logic: Prefer h2 unless only h3 has custom locale/location content
                    var useH2 = h2TitleData && h2TitleData.textValue;
                    var useH3 = h3TitleData && h3TitleData.textValue;
                    
                    // Special case: if h2 exists but has no custom content, and h3 has custom content, prefer h3
                    if (useH2 && useH3 && 
                        !h2TitleData.cstmCnt && h3TitleData.cstmCnt) {
                        useH2 = false; // Switch to h3 only in this specific case
                    } else if (useH2) {
                        useH3 = false; // Standard behavior: prefer h2 when available
                    }
                    
                    // Set the selected title data
                    if (useH2) {
                        text = h2TitleData.textValue;
                        url = h2TitleData.url || '';
                        tag = 'h2';
                    } else if (useH3) {
                        text = h3TitleData.textValue;
                        url = h3TitleData.url || '';
                        tag = 'h3';
                    }
                    
                    // If we have text and isHeading is true, use h1 tag
                    if (text && $scope.isHeading) {
                        tag = 'h1';
                    }
                    
                    // Generate the HTML once
                    if (text) {
                        $scope.titleHtml = generateHeadingHtml(tag, text, url);
                        $scope.hasTitleText = true;
                    }
                }

                activate();
            }
        };
    }


    ProductListSection.$inject = ['ProductService', 'PageTemplateService', '$location', 'matchmedia', '$route', '$rootScope', '$timeout']
    function ProductListSection(ProductService, PageTemplateService, $location, matchmedia, $route, $rootScope, $timeout) {
        return {
            restrict: 'EA',
            scope: {
                isHeading: '=',
                productListProps: '=',
                disableProductFilters: '=',
                recSkus: '=',
            },
            templateUrl: 'shared/js/widget/pageTemplate/product-list-section.html',
            link: function($scope){
                $scope.fetchedProducts;
                $scope.previewProducts;
                $scope.props = {
                    showFilters: true,
                }

                $scope.previewLength = 3;
                $scope.watchers = []
                $scope.watchers.push(matchmedia.onTablet(function(mediaQuery) {
                    if(mediaQuery.matches) {
                        $scope.previewLength = 2;
                    }
                }));

                $scope.$on('pageTemplateQueryParam', function(current, old) {
                    activate();
                })

                function activate(initialLoad) {
                    if (initialLoad) {
                        if ($scope.disableProductFilters) {
                            $scope.props.showFilters = false;
                        }
                        // $scope.$on('productsLoaded', function () {
                        //     $scope.productsLoaded = true;
                        // })

                        $scope.$watch('$root.breadcrumb.isFetching', function() {
                            if ($rootScope.breadcrumb && !$rootScope.breadcrumb.isFetching && $rootScope.breadcrumb.list.length > 0) {
                                $scope.fetchCategoryUmbrella();
                            }
                        }, true)
                        $scope.fetchProducts();
                        $scope.$on('productsLoaded', function(){
                            $scope.productsLoaded = true;
                        })
                    }

                    try {
                        if ($scope.productListProps.productsTitle.dataProps.textValue) {
                            $scope.widgetTitle = $scope.productListProps.productsTitle.dataProps.textValue;
                            $scope.widgetId = $scope.productListProps.productsTitle.dataProps.textValue.replace(/\s/g, '_');
                        }
                    } catch(e) {

                    }

                    $scope.$on('$destroy', function() {
                        _.forEach($scope.watchers, function(watcher){
                            watcher();
                        })
                    })
                }

                function transformNestedTokenList(tagGroups) {
                    return _.map(tagGroups, function(tagGroup) {
                        return tagGroup.searchTokenList
                    });
                }

                function transformFacets(facetGroups) {
                    var facetQuery = {};
                     _.forEach(facetGroups, function(facetGroupArray) {
                        var existingItems = facetQuery[facetGroupArray.key];
                        if (!existingItems) {
                            facetQuery[facetGroupArray.key] = [];
                        }

                        facetQuery[facetGroupArray.key].push(facetGroupArray.searchTokenList);
                    })
                    return facetQuery;
                }


                $scope.fetchProducts = function() {
                    let productFilters = $scope.productListProps.productsQuery.dataProps;
                    var filterRequest = _.omit(productFilters, ['_id', 'dataType'])



                    if (filterRequest.tags) {
                        filterRequest.tags = transformNestedTokenList(filterRequest.tags);
                    }
                    // searchTextList is a nested array -> flatten
                    if (filterRequest.searchTextList) {
                        filterRequest.searchTextList = transformNestedTokenList(filterRequest.searchTextList);
                    }


                    if (filterRequest.productFeatureTags) {
                        filterRequest.productFeatureTags = transformNestedTokenList(filterRequest.productFeatureTags);
                    } else if (filterRequest.productTags) {
                        // legacy
                        filterRequest.productFeatureTags = transformNestedTokenList(filterRequest.productTags);
                    }

                    if (filterRequest.facets) {
                        filterRequest.facets = transformFacets(filterRequest.facets)
                    }
                    return ProductService.fetchProducts(filterRequest, true)
                        .then(function(fetchedProducts) {
                            $scope.fetchedProducts = fetchedProducts;
                            $scope.previewProducts = fetchedProducts.slice(0, Math.min($scope.previewLength, fetchedProducts.length));
                        })
                        .catch(function() {
                            $scope.fetchedProducts = [];
                            $scope.previewProducts = [];
                        })
                        .finally(function(){

                        })
                }

                $scope.categoryUmbrella = {
                    fetching: true
                }

                $scope.fetchCategoryUmbrella = function() {
                    // get parent breadcrumb
                    var parentPage = $rootScope.breadcrumb.list[1];
                    if (parentPage && parentPage._id) {
                        parentPage.displayName = PageTemplateService.cleanPageName(parentPage.targetKeyword, true);
                        PageTemplateService.getProductCategoryUmbrella(parentPage._id)
                            .then(function (children) {
                                // all Page
                                var allPageIndex;
                                var allPage;
                                _.forEach(children, function (page, index) {
                                    if ($rootScope.breadcrumb.list[0].targetKeyword === page.targetKeyword) {
                                        page.isActive = true;
                                    }
                                    page.displayName = PageTemplateService.cleanPageName(page.targetKeyword, true);
                                    if (_.isUndefined(allPageIndex) && (
                                            // page.targetKeyword.includes(' All ') ||
                                            page.pageUrl.endsWith('/all')) ||
                                            page.pageUrl.endsWith('/all-products')
                                    ) {
                                        page.displayName = 'All ' + parentPage.displayName;
                                        allPageIndex = index
                                    }
                                })
                                if (!_.isUndefined(allPageIndex)) {
                                  children.push(children.splice(allPageIndex, 1)[0]) ;

                                }
                                $scope.categoryUmbrella = {
                                    parent: parentPage,
                                    children: children
                                }
                            })
                            .catch(function (e) {
                                $scope.categoryUmbrella = {
                                    fetching: false
                                }
                        })
                    } else {
                        $scope.categoryUmbrella = {
                            fetching: false
                        }
                    }
                }

                activate(true);
            }
        };
    }

    BestSellersSection.$inject = []
    function BestSellersSection() {
        return {
            restrict: 'EA',
            scope: {
                isHeading: '=',
                bestSellersProps: '=',
            },
            templateUrl: 'shared/js/widget/pageTemplate/best-sellers-section.html',
            link: function($scope){
                $scope.bestSellerCategory = {};
                $scope.watchers = [];
                function activate() {

                    $scope.bestSellerCategory.name = $scope.bestSellersProps.bestSellersTitle.dataProps.textValue;
                    $scope.bestSellerCategory.displayName = $scope.bestSellerCategory.name;
                    $scope.bestSellerCategory.skus = _.map($scope.bestSellersProps.skus.dataProps.dataTypeList, function(skuDataType) {
                        return skuDataType.dataProps.sku;
                    })

                    console.log($scope.bestSellerCategory);
                    $scope.$on('$destroy', function() {
                        _.forEach($scope.watchers, function(watcher){
                            watcher();
                        })
                    })
                }

                activate();
            }
        };
    }

    ConfigurableBrandsSection.$inject = []
    function ConfigurableBrandsSection() {
        return {
            restrict: 'EA',
            scope: {
                configBrandsProps: '=',
            },
            templateUrl: 'shared/js/widget/pageTemplate/configurable-brands-section.html',
            link: function($scope){
                $scope.watchers = [];
                $scope.brands;
                function activate() {
                    $scope.brands = $scope.configBrandsProps.brandsList.dataProps.dataTypeList;
                    $scope.$on('$destroy', function() {
                        _.forEach($scope.watchers, function(watcher){
                            watcher();
                        })
                    })
                }

                activate();
            }
        };
    }
})();